export default __webpack_public_path__ + "static/media/money_cashback.c5674df2.png";